export default {
  phone: '电话',
  booth: '展位咨询',
  viewer: '观众咨询',
  customer: '客服',
  online_customer: '在线客服',
  my: '我的',
  vote: '门票',
  cooperate: '展位\n合作'
}
